import Api from './api';

// CRUD da config de SMS do tenant (2DO: /api/configsms). API responde CustomResponse { success, data, errors }
// em minúsculas (LowercaseContractResolver) → acessar data.data.smsproviderid etc. (nunca camelCase).

export const getConfig = async () => {
  let data = [];
  await Api.get('/configsms')
    .then(result => { data = result.data; })
    .catch(err => { data = err; });
  return data;
};

export const getProviders = async () => {
  let data = [];
  await Api.get('/configsms/providers')
    .then(result => { data = result.data; })
    .catch(err => { data = err; });
  return data;
};

export const save = async (payload) => {
  let data = [];
  await Api.post('/configsms', payload)
    .then(result => { data = result.data; })
    .catch(err => { data = err; });
  return data;
};
